import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    serialNumber: Yup.string().required().min(16).max(16),
    passcode: Yup.string().required().min(6).max(6)
})

export default validationSchema
